import { Brand, Position, State } from 'src/types'
import { dxmCanvasGloveFront } from 'src/features/brands/dxm/canvas/rightThrow/glove/front/useDxmCanvasGloveFront'
import { ysrCanvasGloveFront } from 'src/features/brands/yellStory/canvas/glove/front/useYsrCanvasGloveFront'
import { ragdelionCanvasGloveFront } from 'src/features/brands/ragdelion/canvas/glove/rightThrow/front/useRagdelionCanvasGloveFront'
import { gorillaCanvasGloveFront } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/useGorillaCanvasGloveFront'
// import { treasureCanvasGloveFront } from 'src/features/brands/treasure/canvas/glove/front/useTreasureCanvasGloveFront'
import { atomsCanvasGloveFront } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/useAtomsCanvasGloveFront'
import { atomsCanvasFirstMittFront } from 'src/features/brands/atoms/canvas/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { atomsCanvasCatcherMittFront } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/front/useCanvasCatcherMittFront'
import { ragdelionCanvasCatcherMittFront } from 'src/features/brands/ragdelion/canvas/catchermitt/rightThrow/front/useRagdelionCanvasCatcherMittFront'
import { ragdelionCanvasFirstMittFront } from 'src/features/brands/ragdelion/canvas/firstmitt/rightThrow/front/useRagdelionCanvasFirstMittFront'
import { treasureCanvasCatcherMittFront } from 'src/features/brands/treasure/canvas/catchermitt/front/useTreasureCanvasCatcherMittFront'
// import { treasureCanvasFirstMittFront } from 'src/features/brands/treasure/canvas/firstmitt/front/useTreasureCanvasFirstMittFront'
import { gorillaCanvasFirstMittFront } from 'src/features/brands/gorilla/canvas/firstmitt/rightThrow/front/useGorillaCanvasFirstMittFront'
import { gorillaCanvasCatcherMittFront } from 'src/features/brands/gorilla/canvas/catchermitt/rightThrow/front/useGorillaCanvasCatcherMittFront'
import { atomsCanvasGloveFrontLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/glove/front/useAtomsCanvasGloveFront'
import { dxmCanvasGloveFrontLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/glove/front/useDxmCanvasGloveFront'
import { ragdelionCanvasGloveFrontLeftThrow } from 'src/features/brands/ragdelion/canvas/glove/leftThrow/front/useRagdelionCanvasGloveFront'
import { gorillaCanvasGloveFrontLeftThrow } from 'src/features/brands/gorilla/canvas/glove/leftThrow/front/useGorillaCanvasGloveFrontLeftThrow'
import { atomsCanvasFirstMittFrontLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { ragdelionCanvasFirstMittFrontLeftThrow } from 'src/features/brands/ragdelion/canvas/firstmitt/leftThrow/front/useRagdelionCanvasFirstMittFront'
import { gorillaCanvasFirstMittFrontLeftThrow } from 'src/features/brands/gorilla/canvas/firstmitt/leftThrow/front/useGorillaCanvasFirstMittFront'
import { atomsCanvasCatcherMittFrontLeftThrow } from 'src/features/brands/atoms/canvas/leftThrow/catchermitt/front/useCanvasCatcherMittFront'
import { ragdelionCanvasCatcherMittFrontLeftThrow } from 'src/features/brands/ragdelion/canvas/catchermitt/leftThrow/front/useRagdelionCanvasCatcherMittFront'
import { dxmCanvasCatcherMittFront } from 'src/features/brands/dxm/canvas/rightThrow/catcher/front/useCanvasCatcherMittFront'
import { dxmCanvasCatcherMittFrontLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/catcher/front/dxmCanvasCatcherMittFront'
import { dxmCanvasFirstMittFrontLeftThrow } from 'src/features/brands/dxm/canvas/leftThrow/firstmitt/front/useDxmCanvasFirstMittFront'
import { dxmCanvasFirstMittFront } from 'src/features/brands/dxm/canvas/rightThrow/firstmitt/front/useAtomsCanvasFirstMittFront'
import { usModelOfAtomsChecker } from 'src/features/brands/atoms/helper'

export const genFrontImgFromCanvas = (state: State, brand: Brand, beforeCheckPosition: Position, domId?: string): string => {
  const position: Position = Array.isArray(beforeCheckPosition) ? beforeCheckPosition[0] : beforeCheckPosition // 2024/08/01くらいになったら削除
  const canvas = document.getElementById(domId || 'canvasFront') as HTMLCanvasElement
  const ctx = canvas.getContext('2d')
  const productNumber = state.baseModel.productNumber

  const dominantArm = state.dominantArm.value
  const canvasWidth = canvas.width
  ctx.clearRect(0, 0, 900, 652)
  ctx.strokeStyle = '#282828'
  ctx.lineWidth = 2

  if (usModelOfAtomsChecker(productNumber)) {
    atomsCanvasGloveFront(ctx, state, position)
    return
  }

  switch (position) {
    case 'catcher':
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              atomsCanvasCatcherMittFront(ctx, state)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              ragdelionCanvasCatcherMittFront(ctx, state)
              break
          }
          break
        case 'gorilla':
          gorillaCanvasCatcherMittFront(ctx, state)
          break
        case 'treasure':
          treasureCanvasCatcherMittFront(ctx, state)
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasCatcherMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              dxmCanvasCatcherMittFront(ctx, state)
              break
          }
          break
      }
      break
    case 'first':
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              atomsCanvasFirstMittFront(ctx, state)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              ragdelionCanvasFirstMittFront(ctx, state)
              break
          }
          break
        case 'gorilla':
          switch (dominantArm) {
            case 'leftThrow':
              gorillaCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              gorillaCanvasFirstMittFront(ctx, state)
              break
          }
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasFirstMittFrontLeftThrow(ctx, state, canvasWidth)
              break
            default:
              dxmCanvasFirstMittFront(ctx, state)
              break
          }
          break
        // case 'treasure':
        //   treasureCanvasFirstMittFront(ctx, state)
        //   break
      }
      break
    default:
      // glove
      switch (brand) {
        case 'atoms':
          switch (dominantArm) {
            case 'leftThrow':
              atomsCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              atomsCanvasGloveFront(ctx, state, position)
              break
          }
          break
        case 'yellStory':
          ysrCanvasGloveFront(ctx, state)
          break
        case 'dxm':
          switch (dominantArm) {
            case 'leftThrow':
              dxmCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              dxmCanvasGloveFront(ctx, state, position)
              break
          }
          break
        case 'ragdelion':
          switch (dominantArm) {
            case 'leftThrow':
              ragdelionCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              ragdelionCanvasGloveFront(ctx, state, position)
              break
          }
          break
        case 'gorilla':
          switch (dominantArm) {
            case 'leftThrow':
              gorillaCanvasGloveFrontLeftThrow(ctx, state, position, canvasWidth)
              break
            default:
              gorillaCanvasGloveFront(ctx, state, position)
              break
          }
          break
        // case 'treasure':
        //   treasureCanvasGloveFront(ctx, state, position)
        //   break
      }
  }
  return canvas.toDataURL()
}
